// extracted by mini-css-extract-plugin
export default {"questionValueWrapper":"RsvpQuestions_questionValueWrapper__igdhT","label":"RsvpQuestions_label__+uFbE"};